/**
 * Domain Layer - Store Slices Barrel Export
 */

export * from "./ui-slice";
